export default __webpack_public_path__ + "static/media/cases.12b97167.jpg";